import { LEVELS } from "@package/map";

import { Card, Stack, Typography, Switch } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { toggleVisibility } from "Redux/inventorySlice";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { STATIONS3 } from "Constants/Stations";
import { changeMode } from "Redux/fleetSlice";
import MenuButton from "./Button";

export default function Drivers() {
  const dispatch = useAppDispatch();

  const { mode } = useAppSelector((state) => state.fleet);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const setDriversMode = () => {
    if (mode === "drivers") {
      dispatch(changeMode(null));
    } else {
      dispatch(changeMode("drivers"));
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={setDriversMode} checked={mode === "drivers"} />
        </Stack>
      </Stack>
    </Card>
  );
}
